// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import Tdg_EventModel from '../../model/tdg-event-model';
import Tdg_EventDTO from '../dto/tdg-event-dto';
import dtoSchema from '../schemas/tdg-event-schema';

export default abstract class Tdg_EventModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<Tdg_EventDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.creatorId = data.creatorId;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modified = data.modified ?? undefined;
      this.name = data.name ?? undefined;
      this.externalId = data.externalId;
      this.eventTimeStart = data.eventTimeStart;
      this.eventTimeEnd = data.eventTimeEnd;
      this.registrationUntil = data.registrationUntil;
      this.showUntil = data.showUntil;
      this.feedbackUntil = data.feedbackUntil;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;
  /**
  * @type {int64}
  */
  creatorId?: number;
  /**
  * @type {date-time}
  */
  created?: string;
  /**
  * @type {int64}
  */
  modifierId?: number;
  /**
  * @type {date-time}
  */
  modified?: string;
  /**
  */
  name?: string;
  /**
  * @type {uuid}
  */
  externalId?: string;
  /**
  * @type {date-time}
  */
  eventTimeStart?: string;
  /**
  * @type {date-time}
  */
  eventTimeEnd?: string;
  /**
  * @type {date-time}
  */
  registrationUntil?: string;
  /**
  * @type {date-time}
  */
  showUntil?: string;
  /**
  * @type {date-time}
  */
  feedbackUntil?: string;

  static toModel(dto: DeepPartial<Tdg_EventDTO>): Tdg_EventModel;
  static toModel(dto: DeepPartial<Tdg_EventDTO> | undefined | null): Tdg_EventModel | undefined;
  static toModel(dto: DeepPartial<Tdg_EventDTO> | undefined | null): Tdg_EventModel | undefined {
    return dto ? new Tdg_EventModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<Tdg_EventModel> | Tdg_EventModel): Tdg_EventDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      creatorId: unwrapped.creatorId,
      created: unwrapped.created,
      modifierId: unwrapped.modifierId,
      modified: unwrapped.modified,
      name: unwrapped.name,
      externalId: unwrapped.externalId,
      eventTimeStart: unwrapped.eventTimeStart,
      eventTimeEnd: unwrapped.eventTimeEnd,
      registrationUntil: unwrapped.registrationUntil,
      showUntil: unwrapped.showUntil,
      feedbackUntil: unwrapped.feedbackUntil,
    } as Tdg_EventDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for Tdg_EventModel, can not map to Tdg_EventDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
